import { useContext } from 'react';

// auth provider
import { ClubsContext } from 'contexts/ClubsContext';
// import AuthContext from 'contexts/Auth0Context';
// import AuthContext from 'contexts/JWTContext';
// import AuthContext from 'contexts/AWSCognitoContext';

// ==============================|| AUTH HOOKS ||============================== //

const useClubs = () => {
    const context = useContext(ClubsContext);

    if (!context) throw new Error('context must be use inside provider');

    return context;
};

export default useClubs;
